import {useRouteLoaderData} from '@remix-run/react'
import {useSyncExternalStore} from 'react'
import type {RootLoaderResponse} from '~/types'
import {getConsentState, isTrackingAllowed, subscribeToConsentChanges} from '~/utils/consent-manager.client'

function getIsTrackingAllowed(): boolean {
  if (typeof window === 'undefined') return true
  return isTrackingAllowed()
}

export function useAnalyticsConsent() {
  const {gdprConsentData, cookieConsentVariation} = useRouteLoaderData('root') as RootLoaderResponse

  const clientConsentState = useSyncExternalStore(
    subscribeToConsentChanges,
    () => getConsentState(),
    () => gdprConsentData,
  )

  const effectiveConsentData = clientConsentState ?? gdprConsentData

  const hasAnswered = effectiveConsentData !== null
  const isAccepted = hasAnswered && effectiveConsentData === 'granted'

  const isTrackingBlocked = !getIsTrackingAllowed()

  let hasConsent: boolean

  switch (cookieConsentVariation) {
    case 'opt-in':
      hasConsent = hasAnswered && isAccepted && !isTrackingBlocked
      break

    case 'opt-out':
      hasConsent = (!hasAnswered || isAccepted) && !isTrackingBlocked
      break

    case 'got-it':
    default:
      hasConsent = !isTrackingBlocked
      break
  }

  return {
    hasConsent,
    hasAnswered,
    isAccepted,
    optOutRejected: isTrackingBlocked || (cookieConsentVariation === 'opt-out' && hasAnswered && !isAccepted),
  }
}
